import import_latest_version_module from '@/component/admin-layout/import_latest_version_module';

export default {
  path: '',
  component: () => import_latest_version_module(),
  children: [
    {
      path: '/admin/plain-order-audit',
      name: 'admin-plain-order-audit',
      component: () => import(/* webpackChunkName: "page-admin-plain-order-management-plain-order-audit" */ `./index.vue`),
      meta: {
          data_for_admin_layout: {
                    data_for_history_tag: {
                              entity: {
                                        name: "订单审核"
                              }
                    },
                    data_for_breadcrumb: {
                              entity_list: [
                                        {
                                                  name: "订单管理"
                                        },
                                        {
                                                  name: "订单审核"
                                        }
                              ]
                    }
          }
},
    },
  ],
};
